module.exports = __webpack_public_path__ + "a98e655a91b19c0e789f976f3db89fcf.png";